module.exports = __webpack_public_path__ + "static/media/benefits1.846291e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/benefits1.png
// module id = 1209
// module chunks = 0